const actions = {
  SET_STATE: 'appsettings/SET_STATE',
  CHANGE_SETTING: 'appsettings/CHANGE_SETTING',
}

export default actions
